var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1.6em",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3 0 0 3 540 525)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    strokeWidth: 20,
    fill: "white",
    transform: " translate(-190, -250)",
    d: "M 320 464 C 328.8 464 336 456.8 336 448 L 336 160 L 256 160 C 238.3 160 224 145.7 224 128 L 224 48 L 64 48 C 55.2 48 48 55.2 48 64 L 48 448 C 48 456.8 55.2 464 64 464 L 320 464 z M 0 64 C 0 28.7 28.7 0 64 0 L 229.5 0 C 246.5 0 262.8 6.7 274.8 18.7 L 365.3 109.2 C 377.3 121.2 384 137.5 384 154.5 L 384 448 C 384 483.3 355.3 512 320 512 L 64 512 C 28.700000000000003 512 0 483.3 0 448 L 0 64 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDocumentIcon);
export default __webpack_public_path__ + "static/media/AddDocumentIcon.bcb328d98c052c8248566eae49ab86e5.svg";
export { ForwardRef as ReactComponent };